import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { IonApp, IonRouterOutlet, IonRow } from '@ionic/angular/standalone';
import { IonIcon } from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';
import { search, personSharp, send, informationCircle, arrowBackCircleOutline, refresh, close, arrowDownCircle, copy, personCircle, arrowForwardOutline, arrowForward, arrowUpCircleSharp, caretUpCircle, document, closeCircle, logOut, arrowBackCircleSharp, lockClosed, person, eye, eyeOff, helpOutline } from 'ionicons/icons';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

declare var Gradient: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, CommonModule, FormsModule],
})
export class AppComponent {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    @Inject(DOCUMENT) private documentEl: Document,
    private router: Router
  ) {
    addIcons({
      arrowUpCircleSharp,
      arrowBackCircleSharp,
      arrowBackCircleOutline,
      lockClosed,
      person,
      eye,
      eyeOff,
      logOut,
      document,
      closeCircle,
      caretUpCircle,
      search,
      arrowForwardOutline,
      arrowForward,
      personSharp,
      personCircle,
      copy,
      close,
      arrowDownCircle,
      refresh,
      send,
      informationCircle,
      helpOutline
    });
  }

  public_key: string | null = null;

  agents: any;
  agentsSettings: any;

  isOnChatPage = false;

  ngOnInit() {
    const url = new URL(window.location.href);
    const company_id = url.searchParams.get('company_id');
    this.public_key = url.searchParams.get('public_key');
    if (this.public_key) {
      localStorage.setItem('public_key', this.public_key || '');
    }

    const chatId = url.searchParams.get('chatId');
    localStorage.setItem('company_id', company_id || '');

    if (!chatId) {
      localStorage.removeItem('chatId');
    }

    const token =  url.searchParams.get('token');

    if (token) {
      this.authService.setToken(token);
      localStorage.setItem('token', token);
    }

    this.agents = this.apiService.agents;
    if (!this.agents) {
      this.setBackground();

      this.apiService.agentsChanges.subscribe((agents: any) => {
        this.agents = agents;
        this.agentsSettings = this.agents[0].company;

        this.setBackground();
      });
    } else {
      this.setBackground();
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      // Check if current route is a chat page
      this.isOnChatPage = event.url.includes('/chat/');
    });
  }

  @ViewChild('gradientCanvas') canvasRef!: ElementRef;

  chatId: string | null = null // Retrieve chatId from localStorage

  get isChatIdPresent(): boolean {
    return !!this.chatId;
  }

  ngAfterViewInit() {
    this.chatId = localStorage.getItem('chatId');
    if (this.chatId) {
      // this.renderer.setStyle(this.documentEl.body, '--ion-background-color', '#fff');
      this.documentEl.body.style.setProperty('--ion-background-color', '#fff');
      return
    }


    const canvas = this.canvasRef.nativeElement;
    if (canvas) {
      try {
        const gradient = new Gradient();

        gradient.initGradient('#gradient-canvas');
      } catch (err) {
        console.error('Erreur d’initialisation du gradient :', err);
      }
    } else {
      console.error('Canvas non trouvé');
    }
  }


  backgroundImg: string = '';

  setBackground() {
    if (this.agentsSettings && (this.agentsSettings.agents_back_type == "gradient" || !this.agentsSettings.agents_back_type)) {
      
      const color1 = this.agentsSettings.agents_bck_color1 ? this.agentsSettings.agents_bck_color1 : '#e28245';
      const color2 = this.agentsSettings.agents_bck_color2 ? this.agentsSettings.agents_bck_color2 : '#efca84';
      const color3 = this.agentsSettings.agents_bck_color3 ? this.agentsSettings.agents_bck_color3 : '#adc6c6';

      this.setGradientColors({
        color1: color1,
        color2: color2,
        color3: color3,
      });
    } else if (this.agentsSettings && this.agentsSettings.agents_back_type == "image") {
      this.backgroundImg = this.agentsSettings?.agents_bck_image_url;
    } else {
      // Default gradient colors if no settings are provided
      this.setGradientColors({
        color1: '#e28245',
        color2: '#efca84',
        color3: '#adc6c6',
      });
    }
  }

  // Add this method to your AppComponent class
  setGradientColors(colors: {
    color1?: string,
    color2?: string,
    color3?: string,
    color4?: string
  }) {
    if (colors.color1) {
      this.documentEl.body.style.setProperty('--gradient-color-1', colors.color1);
    }
    if (colors.color2) {
      this.documentEl.body.style.setProperty('--gradient-color-2', colors.color2);
    }
    if (colors.color3) {
      this.documentEl.body.style.setProperty('--gradient-color-3', colors.color3);
    }
    if (colors.color4) {
      this.documentEl.body.style.setProperty('--gradient-color-4', colors.color4);
    }

    // If you need to reinitialize the gradient after changing colors
    this.reinitializeGradient();
  }

  // Optional: Add this if you need to reinitialize the gradient after color changes
  reinitializeGradient() {
    const canvas = this.canvasRef?.nativeElement;
    if (canvas) {
      try {
        const gradient = new Gradient();
        gradient.initGradient('#gradient-canvas');
      } catch (err) {
        console.error('Error reinitializing gradient:', err);
      }
    }
  }
}
